// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   App Sidebar - Flat Design System
   Uses CSS variables from colors.css
   =================================== */

/* ===================================
   Top Navbar (Unauthenticated Users)
   =================================== */

.app-topnav {
  width: 100%;
  height: 56px;
  background: var(--color-bg-canvas-surface);
  border-bottom: 1px solid var(--color-border-input);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.app-topnav__container {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.app-topnav__logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.app-topnav__logo {
  height: 40px;
  width: auto;
  transition: opacity 0.15s ease;
}

.app-topnav__logo-link:hover .app-topnav__logo {
  opacity: 0.7;
}

.app-topnav__nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 32px;
}

.app-topnav__link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  transition: all 0.15s ease;
  cursor: pointer;
  border: none;
  background: transparent;
}

.app-topnav__link:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.app-topnav__link--dropdown {
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
}

.app-topnav__link--dropdown svg {
  transition: transform 0.15s ease;
}

.app-topnav__link--dropdown[data-state="open"] svg {
  transform: rotate(180deg);
}

/* ===================================
   Resources Dropdown - Flat Design
   =================================== */

.resources-dropdown {
  width: 380px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 4px;
  z-index: 1000;
  animation: resourcesDropdownIn 0.15s ease;
}

@keyframes resourcesDropdownIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.resources-dropdown__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
}

/* Base panel styles */
.resources-dropdown__panel {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  outline: none;
  background: transparent;
  border: none;
  transition: background 0.15s ease;
}

.resources-dropdown__panel:hover,
.resources-dropdown__panel:focus {
  background: var(--color-bg-user-bubble);
}

/* Panel icon */
.resources-dropdown__panel-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
}

/* Panel content */
.resources-dropdown__panel-content {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1 1;
  min-width: 0;
}

.resources-dropdown__panel-title {
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  color: var(--color-text-primary);
}

.resources-dropdown__panel-desc {
  font-size: 11px;
  font-weight: 400;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  color: var(--color-text-secondary);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Full-width panels (Documentation & Blog) */
.resources-dropdown__panel--featured,
.resources-dropdown__panel--blog {
  grid-column: 1 / -1;
}

/* Icon variations - all use same neutral style */
.resources-dropdown__panel-icon--docs,
.resources-dropdown__panel-icon--youtube,
.resources-dropdown__panel-icon--tutorials,
.resources-dropdown__panel-icon--blog {
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
}

/* ===================================
   Resources Dropdown Mobile
   =================================== */

@media (max-width: 540px) {
  .resources-dropdown {
    width: calc(100vw - 32px);
    max-width: 340px;
  }

  .resources-dropdown__grid {
    grid-template-columns: 1fr;
  }
}

/* Actions (right side) */
.app-topnav__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.app-topnav__signin-btn {
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.app-topnav__signin-btn:hover {
  background: var(--color-bg-user-bubble);
}

.app-topnav__cta-btn {
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.app-topnav__cta-btn:hover {
  background: var(--color-bg-user-bubble);
}

/* Mobile responsiveness for topnav */
@media (max-width: 768px) {
  .app-topnav__container {
    padding: 0 16px;
  }

  .app-topnav__nav {
    display: none;
  }

  .app-topnav__signin-btn {
    display: none;
  }
}

/* ===================================
   Left Sidebar (Authenticated Users)
   =================================== */

.app-sidebar {
  width: 220px;
  height: 100vh;
  background: var(--color-bg-sidebar);
  border-right: 1px solid var(--color-border-sidebar);
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  transition: width 0.2s ease;
  position: relative;
  z-index: 50;
  flex-shrink: 0;
}

.app-sidebar--collapsed {
  width: 56px;
  padding: 12px 8px;
  cursor: pointer;
}

.app-sidebar--collapsed:hover {
  background: var(--color-bg-canvas-surface);
}

/* Header */
.app-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px 16px;
  gap: 8px;
}

.app-sidebar--collapsed .app-sidebar__header {
  justify-content: center;
  padding: 4px 0 16px;
}

.app-sidebar__logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.app-sidebar__logo {
  height: 18px;
  width: auto;
  transition: opacity 0.15s ease;
}

.app-sidebar--collapsed .app-sidebar__logo {
  height: 18px;
}

.app-sidebar__logo-link:hover .app-sidebar__logo {
  opacity: 0.7;
}

.app-sidebar__collapse-btn {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.app-sidebar__collapse-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.app-sidebar__collapse-btn svg {
  transition: transform 0.2s ease;
}

.app-sidebar--collapsed .app-sidebar__collapse-btn {
  display: none;
}

/* Navigation */
.app-sidebar__nav {
  flex: 0 0 auto;
}

.app-sidebar__nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.app-sidebar__nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 4px;
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  transition: all 0.15s ease;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
}

.app-sidebar__nav-item:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.app-sidebar__nav-item--active {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.app-sidebar__nav-item svg {
  flex-shrink: 0;
  opacity: 0.8;
}

.app-sidebar__nav-item--active svg {
  opacity: 1;
}

.app-sidebar--collapsed .app-sidebar__nav-item {
  justify-content: center;
  padding: 10px;
}

/* Spacer */
.app-sidebar__spacer {
  flex: 1 1 auto;
  min-height: 16px;
}

.app-sidebar--collapsed .app-sidebar__spacer {
  cursor: pointer;
}

/* Bottom section */
.app-sidebar__bottom {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--color-border-input);
}

/* Payment banner */
.app-sidebar__payment-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 4px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: 6px;
  color: inherit;
  text-align: left;
  text-decoration: none;
}

.app-sidebar__payment-banner:hover {
  background: var(--color-bg-user-bubble);
}

.app-sidebar__payment-banner:disabled {
  opacity: 0.5;
  cursor: wait;
}

/* Credit balance banner */
.app-sidebar__credit-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: 1px solid var(--color-border-input);
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}

.app-sidebar__credit-banner:hover {
  background: var(--color-bg-user-bubble);
}

.app-sidebar__credit-banner--low {
  border-color: var(--color-danger, #e55);
}

.app-sidebar__credit-banner--low .app-sidebar__payment-subtitle {
  color: var(--color-danger, #e55);
}

.app-sidebar__credit-icon--low {
  color: var(--color-danger, #e55);
}

.app-sidebar__payment-icon {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

.app-sidebar__payment-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1 1;
}

.app-sidebar__payment-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
}

.app-sidebar__payment-subtitle {
  font-size: 10px;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
}

/* Collapsed payment icon button */
.app-sidebar__payment-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  margin: 0 auto 6px;
}

.app-sidebar__payment-icon-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.app-sidebar__payment-icon-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}

/* Profile section */
.app-sidebar__profile {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border-radius: 4px;
  transition: background 0.15s ease;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  outline: none;
}

.app-sidebar__profile:hover {
  background: var(--color-bg-user-bubble);
}

.app-sidebar--collapsed .app-sidebar__profile {
  justify-content: center;
  padding: 6px 0;
}

.app-sidebar__avatar {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
}

.app-sidebar__avatar:hover {
  border-color: var(--color-text-secondary);
}

.app-sidebar__avatar img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  object-fit: cover;
}

.app-sidebar__profile-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.app-sidebar__profile-email {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-sidebar--collapsed .app-sidebar__profile-info {
  display: none;
}

/* Tooltips */
.app-sidebar__tooltip {
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  font-size: 12px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  z-index: 1000;
  animation: tooltipFadeIn 0.15s ease;
}

.app-sidebar__tooltip--logout {
  padding: 0;
}

.app-sidebar__tooltip-arrow {
  fill: var(--color-bg-canvas-surface);
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Logout button in tooltip */
.app-sidebar__logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s ease;
  white-space: nowrap;
}

.app-sidebar__logout-btn:hover {
  background: var(--color-bg-user-bubble);
}

.app-sidebar__logout-btn svg {
  flex-shrink: 0;
  opacity: 0.7;
}

/* Get Started button for unauthenticated users */
.app-sidebar__get-started-btn {
  width: 100%;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.app-sidebar__get-started-btn:hover {
  background: var(--color-bg-user-bubble);
}

.app-sidebar--collapsed .app-sidebar__get-started-btn {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .app-sidebar {
    width: 56px;
    padding: 12px 8px;
  }

  .app-sidebar__header {
    justify-content: center;
    padding: 4px 0 16px;
  }

  .app-sidebar__collapse-btn {
    display: none;
  }

  .app-sidebar__nav-item {
    justify-content: center;
    padding: 10px;
  }

  .app-sidebar__nav-item span,
  .app-sidebar__payment-banner,
  .app-sidebar__credit-banner,
  .app-sidebar__profile-info {
    display: none;
  }

  .app-sidebar__profile {
    justify-content: center;
    padding: 6px 0;
  }

  /* Show collapsed payment icon on mobile */
  .app-sidebar__payment-icon-btn {
    display: flex;
  }
}

/* Earn \$10 referral link subtle accent */
.app-sidebar__nav-item--earn {
  color: var(--color-accent-base, #c07b42);
}

.app-sidebar__nav-item--earn:hover {
  color: var(--color-accent-base, #c07b42);
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppSidebar.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;;wCAEwC;;AAExC;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kDAAkD;EAClD,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;wCAEwC;;AAExC;EACE,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;;EAEE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;;;;EAIE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;wCAEwC;;AAExC;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;wCAEwC;;AAExC;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kEAAkE;AACpE;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kEAAkE;EAClE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf","sourcesContent":["/* ===================================\n   App Sidebar - Flat Design System\n   Uses CSS variables from colors.css\n   =================================== */\n\n/* ===================================\n   Top Navbar (Unauthenticated Users)\n   =================================== */\n\n.app-topnav {\n  width: 100%;\n  height: 56px;\n  background: var(--color-bg-canvas-surface);\n  border-bottom: 1px solid var(--color-border-input);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n.app-topnav__container {\n  max-width: 1400px;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n}\n\n.app-topnav__logo-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.app-topnav__logo {\n  height: 40px;\n  width: auto;\n  transition: opacity 0.15s ease;\n}\n\n.app-topnav__logo-link:hover .app-topnav__logo {\n  opacity: 0.7;\n}\n\n.app-topnav__nav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 32px;\n}\n\n.app-topnav__link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n}\n\n.app-topnav__link:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.app-topnav__link--dropdown {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n}\n\n.app-topnav__link--dropdown svg {\n  transition: transform 0.15s ease;\n}\n\n.app-topnav__link--dropdown[data-state=\"open\"] svg {\n  transform: rotate(180deg);\n}\n\n/* ===================================\n   Resources Dropdown - Flat Design\n   =================================== */\n\n.resources-dropdown {\n  width: 380px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 4px;\n  z-index: 1000;\n  animation: resourcesDropdownIn 0.15s ease;\n}\n\n@keyframes resourcesDropdownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.resources-dropdown__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2px;\n}\n\n/* Base panel styles */\n.resources-dropdown__panel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 4px;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n  background: transparent;\n  border: none;\n  transition: background 0.15s ease;\n}\n\n.resources-dropdown__panel:hover,\n.resources-dropdown__panel:focus {\n  background: var(--color-bg-user-bubble);\n}\n\n/* Panel icon */\n.resources-dropdown__panel-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n}\n\n/* Panel content */\n.resources-dropdown__panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  flex: 1;\n  min-width: 0;\n}\n\n.resources-dropdown__panel-title {\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  color: var(--color-text-primary);\n}\n\n.resources-dropdown__panel-desc {\n  font-size: 11px;\n  font-weight: 400;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  color: var(--color-text-secondary);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Full-width panels (Documentation & Blog) */\n.resources-dropdown__panel--featured,\n.resources-dropdown__panel--blog {\n  grid-column: 1 / -1;\n}\n\n/* Icon variations - all use same neutral style */\n.resources-dropdown__panel-icon--docs,\n.resources-dropdown__panel-icon--youtube,\n.resources-dropdown__panel-icon--tutorials,\n.resources-dropdown__panel-icon--blog {\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n}\n\n/* ===================================\n   Resources Dropdown Mobile\n   =================================== */\n\n@media (max-width: 540px) {\n  .resources-dropdown {\n    width: calc(100vw - 32px);\n    max-width: 340px;\n  }\n\n  .resources-dropdown__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Actions (right side) */\n.app-topnav__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.app-topnav__signin-btn {\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.app-topnav__signin-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-topnav__cta-btn {\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.app-topnav__cta-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n/* Mobile responsiveness for topnav */\n@media (max-width: 768px) {\n  .app-topnav__container {\n    padding: 0 16px;\n  }\n\n  .app-topnav__nav {\n    display: none;\n  }\n\n  .app-topnav__signin-btn {\n    display: none;\n  }\n}\n\n/* ===================================\n   Left Sidebar (Authenticated Users)\n   =================================== */\n\n.app-sidebar {\n  width: 220px;\n  height: 100vh;\n  background: var(--color-bg-sidebar);\n  border-right: 1px solid var(--color-border-sidebar);\n  display: flex;\n  flex-direction: column;\n  padding: 12px 10px;\n  transition: width 0.2s ease;\n  position: relative;\n  z-index: 50;\n  flex-shrink: 0;\n}\n\n.app-sidebar--collapsed {\n  width: 56px;\n  padding: 12px 8px;\n  cursor: pointer;\n}\n\n.app-sidebar--collapsed:hover {\n  background: var(--color-bg-canvas-surface);\n}\n\n/* Header */\n.app-sidebar__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 6px 16px;\n  gap: 8px;\n}\n\n.app-sidebar--collapsed .app-sidebar__header {\n  justify-content: center;\n  padding: 4px 0 16px;\n}\n\n.app-sidebar__logo-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.app-sidebar__logo {\n  height: 18px;\n  width: auto;\n  transition: opacity 0.15s ease;\n}\n\n.app-sidebar--collapsed .app-sidebar__logo {\n  height: 18px;\n}\n\n.app-sidebar__logo-link:hover .app-sidebar__logo {\n  opacity: 0.7;\n}\n\n.app-sidebar__collapse-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.app-sidebar__collapse-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.app-sidebar__collapse-btn svg {\n  transition: transform 0.2s ease;\n}\n\n.app-sidebar--collapsed .app-sidebar__collapse-btn {\n  display: none;\n}\n\n/* Navigation */\n.app-sidebar__nav {\n  flex: 0 0 auto;\n}\n\n.app-sidebar__nav-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.app-sidebar__nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 4px;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n  text-align: left;\n}\n\n.app-sidebar__nav-item:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.app-sidebar__nav-item--active {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.app-sidebar__nav-item svg {\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.app-sidebar__nav-item--active svg {\n  opacity: 1;\n}\n\n.app-sidebar--collapsed .app-sidebar__nav-item {\n  justify-content: center;\n  padding: 10px;\n}\n\n/* Spacer */\n.app-sidebar__spacer {\n  flex: 1 1 auto;\n  min-height: 16px;\n}\n\n.app-sidebar--collapsed .app-sidebar__spacer {\n  cursor: pointer;\n}\n\n/* Bottom section */\n.app-sidebar__bottom {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 10px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n/* Payment banner */\n.app-sidebar__payment-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  margin-bottom: 6px;\n  color: inherit;\n  text-align: left;\n  text-decoration: none;\n}\n\n.app-sidebar__payment-banner:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-sidebar__payment-banner:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n/* Credit balance banner */\n.app-sidebar__credit-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.app-sidebar__credit-banner:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-sidebar__credit-banner--low {\n  border-color: var(--color-danger, #e55);\n}\n\n.app-sidebar__credit-banner--low .app-sidebar__payment-subtitle {\n  color: var(--color-danger, #e55);\n}\n\n.app-sidebar__credit-icon--low {\n  color: var(--color-danger, #e55);\n}\n\n.app-sidebar__payment-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n}\n\n.app-sidebar__payment-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  flex: 1;\n}\n\n.app-sidebar__payment-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n}\n\n.app-sidebar__payment-subtitle {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n}\n\n/* Collapsed payment icon button */\n.app-sidebar__payment-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  margin: 0 auto 6px;\n}\n\n.app-sidebar__payment-icon-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.app-sidebar__payment-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n/* Profile section */\n.app-sidebar__profile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px;\n  border-radius: 4px;\n  transition: background 0.15s ease;\n  width: 100%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  outline: none;\n}\n\n.app-sidebar__profile:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-sidebar--collapsed .app-sidebar__profile {\n  justify-content: center;\n  padding: 6px 0;\n}\n\n.app-sidebar__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n}\n\n.app-sidebar__avatar:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.app-sidebar__avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 3px;\n  object-fit: cover;\n}\n\n.app-sidebar__profile-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.app-sidebar__profile-email {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-sidebar--collapsed .app-sidebar__profile-info {\n  display: none;\n}\n\n/* Tooltips */\n.app-sidebar__tooltip {\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  padding: 6px 10px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  z-index: 1000;\n  animation: tooltipFadeIn 0.15s ease;\n}\n\n.app-sidebar__tooltip--logout {\n  padding: 0;\n}\n\n.app-sidebar__tooltip-arrow {\n  fill: var(--color-bg-canvas-surface);\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Logout button in tooltip */\n.app-sidebar__logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n\n.app-sidebar__logout-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-sidebar__logout-btn svg {\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n/* Get Started button for unauthenticated users */\n.app-sidebar__get-started-btn {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.app-sidebar__get-started-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.app-sidebar--collapsed .app-sidebar__get-started-btn {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .app-sidebar {\n    width: 56px;\n    padding: 12px 8px;\n  }\n\n  .app-sidebar__header {\n    justify-content: center;\n    padding: 4px 0 16px;\n  }\n\n  .app-sidebar__collapse-btn {\n    display: none;\n  }\n\n  .app-sidebar__nav-item {\n    justify-content: center;\n    padding: 10px;\n  }\n\n  .app-sidebar__nav-item span,\n  .app-sidebar__payment-banner,\n  .app-sidebar__credit-banner,\n  .app-sidebar__profile-info {\n    display: none;\n  }\n\n  .app-sidebar__profile {\n    justify-content: center;\n    padding: 6px 0;\n  }\n\n  /* Show collapsed payment icon on mobile */\n  .app-sidebar__payment-icon-btn {\n    display: flex;\n  }\n}\n\n/* Earn $10 referral link subtle accent */\n.app-sidebar__nav-item--earn {\n  color: var(--color-accent-base, #c07b42);\n}\n\n.app-sidebar__nav-item--earn:hover {\n  color: var(--color-accent-base, #c07b42);\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
